
export class ProgramAnalyticsNav {
  public static item = {
    title: 'program.tab.analytics',
    url: 'analytics',
    icon: '<img src="./assets/icons/line-icons/nav/grey/analytics.svg" width="23px" height="23px">',
    testId: 'prog-nav-analytics',
  };
}
